import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import moment from 'moment';
import { ControlLabel, FormControl, FormGroup } from 'react-bootstrap';

import ManagedInput from 'components/form/managed_input';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './styles.scss';

export default class FilterDatePickerPair extends React.Component {
  static propTypes = {
    ...FormControl.propTypes,
    filter: PropTypes.object.isRequired,
    inputsOnly: PropTypes.bool,
    label: PropTypes.string,
    maxPlaceholder: PropTypes.string,
    minPlaceholder: PropTypes.string,
    newDesignSystem: PropTypes.bool,
    placeholder: PropTypes.string,
    valueKeys: PropTypes.array.isRequired,
    withIcon: PropTypes.any,
    onChange: PropTypes.func.isRequired
  };


  static defaultProps = {
    newDesignSystem: false
  };

  minKey = () => this.props.valueKeys[0];
  maxKey = () => this.props.valueKeys[1];

  minValue = () => this.props.filter[this.minKey()];
  maxValue = () => this.props.filter[this.maxKey()];

  handleMaxChange = (e) => {
    this.props.onChange(e, this.maxKey());
  };

  handleMinChange = (e) => {
    this.props.onChange(e, this.minKey());
  };

  render() {
    const { inputsOnly, label, newDesignSystem } = this.props;
    let endDate = this.maxValue();
    if (endDate) endDate = moment(endDate);
    let startDate = this.minValue();
    if (startDate) startDate = moment(startDate);

    if (newDesignSystem) {
      return (
        <div>
          {label && <ControlLabel>{label}</ControlLabel>}
          <FormGroup className={'input-pair-container m-0 d-flex align-items-center'}>
            {this.renderMin(startDate, endDate)}
            {!inputsOnly && <span className={'pl-2 pr-2'}> - </span>}
            {this.renderMax(startDate, endDate)}
          </FormGroup>
        </div>
      );
    } else {
      return (
        <div>
          {label && <ControlLabel>{label}</ControlLabel>}
          <FormGroup className={'input-pair-container'}>
            {this.renderMin(startDate, endDate)}
            {!inputsOnly && <span className={'top-buffer-xs pl-2 pr-2'}> TO </span>}
            {this.renderMax(startDate, endDate)}
          </FormGroup>
        </div>
      );
    }
  }

  renderMin(startDate, endDate) {
    const { newDesignSystem, minPlaceholder, placeholder, withIcon } = this.props;

    if (newDesignSystem) {
      return (
        <span className="input-pair">
          {withIcon && <FontAwesomeIcon className="input-icon" icon={withIcon} />}
          <ManagedInput
            aria-label={`minimum ${this.props['aria-label']}`}
            className={`input-selection form-control ${withIcon ? 'with-icon' : ''}`}
            endDate={endDate}
            name={`${name}_min`}
            placeholder={minPlaceholder || placeholder || 'Start'}
            selectsStart
            startDate={startDate}
            type="date"
            value={startDate}
            onValueChange={this.handleMinChange}
          />
        </span>
      );
    } else {
      return (
        <span className="right-buffer-sm input-pair">
          <ManagedInput
            aria-label={`minimum ${this.props['aria-label']}`}
            className="form-control"
            endDate={endDate}
            name={`${name}_min`}
            placeholder={minPlaceholder || placeholder || 'Start'}
            selectsStart
            startDate={startDate}
            type="date"
            value={startDate}
            onValueChange={this.handleMinChange}
          />
        </span>
      );
    }
  }


  renderMax(startDate, endDate) {
    const { inputsOnly, newDesignSystem, maxPlaceholder, placeholder, withIcon } = this.props;

    if (newDesignSystem) {
      return (
        <span className="input-pair">
          {withIcon && <FontAwesomeIcon className="input-icon" icon={withIcon} />}
          <ManagedInput
            aria-label={`maximum ${this.props['aria-label']}`}
            className={`input-selection form-control ${withIcon ? 'with-icon' : ''}`}
            endDate={endDate}
            name={`${name}_max`}
            placeholder={maxPlaceholder || placeholder || 'End'}
            selectsEnd
            startDate={startDate}
            type="date"
            value={endDate}
            onValueChange={this.handleMaxChange}
          />
        </span>
      );
    } else {
      return (
        <span className={classNames('input-pair', { 'left-buffer-sm': !inputsOnly })}>
          <ManagedInput
            aria-label={`maximum ${this.props['aria-label']}`}
            className="form-control"
            endDate={endDate}
            name={`${name}_max`}
            placeholder={maxPlaceholder || placeholder || 'End'}
            selectsEnd
            startDate={startDate}
            type="date"
            value={endDate}
            onValueChange={this.handleMaxChange}
          />
        </span>
      );
    }
  }
}
